import Text from '~/core/Text'
import { QuantityType } from '../../types'

export default function QuantityData(props: QuantityType) {
    const { quantity, totalQuantity } = props

    const textQuantity =
        quantity !== totalQuantity ? (
            <span>
                {quantity} of {totalQuantity}
            </span>
        ) : (
            totalQuantity
        )

    const textPartialShipment =
        quantity !== totalQuantity ? (
            <Text fontWeight={100} element="div">
                {' '}
                Shipped{' '}
            </Text>
        ) : (
            ''
        )

    return (
        <div style={{ textAlign: 'center' }}>
            {textQuantity}
            {textPartialShipment}
        </div>
    )
}
